export const NotFound = () => {
  return (
    <>
      Page not found.
    </>
  )
}